import type { SignInConsent } from '@core/tellent-types';
import type { NewDataTableColumn } from '@core/user-interface-legacy';

export type ConsentTableColumn = NewDataTableColumn<SignInConsent>;

export enum ConsentHistoryColumn {
  History = 'history',
  Status = 'status',
}
